<template>
  <div>
    <el-dialog
      title="服务老人信息"
      :visible.sync="oldId.state"
      width="70%"
      @close="dialogVisibleClone"
      append-to-body
      class="dialog_container"
    >
      <hr style="margin-bottom: 20px" color="#CCCCCC" />

      <div class="name-per">
        <div
          v-for="(item, index) in titleList"
          :key="index"
          class="name-list"
          @click="changeIdx(item.id)"
        >
          <div>
            <div
              class="name-title"
              :class="{
                changeColor: controlAddContent == item.id,
              }"
            >
              <div></div>
              <div><i class="el-icon-circle-check"></i></div>
              <div></div>
            </div>
            <div class="name-bottom">{{ item.name }}</div>
          </div>
        </div>
      </div>

      <!-- 基本信息 -->
      <el-form
        v-show="controlAddContent == 1"
        ref="formRef"
        :model="formData"
        label-width="100px"
      >
        <div class="serviceInfoBox">
          <div>
            <el-form-item label="姓名:" required prop="customerName">
              <el-input
                v-model="formData.customerName"
                placeholder="请输入"
                disabled
                style="width: 475px"
              ></el-input>
            </el-form-item>
            <el-form-item label="身份证号:" required prop="idCard">
              <el-input
                v-model="formData.idCard"
                disabled
                placeholder="请输入"
                style="width: 475px"
              ></el-input>
            </el-form-item>
            <el-form-item label="性别:" prop="gender">
              <el-select
                v-model="formData.gender"
                disabled
                placeholder="请选择"
                style="width: 475px"
              >
                <el-option label="男" value="0"></el-option>
                <el-option label="女" value="1"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="年龄:">
              <el-input
                style="width: 475px"
                disabled
                v-model="formData.age"
              ></el-input>
            </el-form-item>
            <el-form-item label="联系方式:" required prop="phone">
              <el-input
                v-model="formData.phone"
                placeholder="请输入"
                disabled
                style="width: 475px"
              ></el-input>
            </el-form-item>

            <el-form-item label="类别:" required prop="serviceType">
              <el-select
                v-model="formData.serviceType"
                disabled
                placeholder="请选择"
                style="width: 475px"
              >
                <el-option
                  v-for="(item, index) in serviceTypeList"
                  :key="index"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="rightBox">
            <el-form-item prop="photo" style="margin-left=0px;">
              <el-upload
                class="avatar-uploader"
                :action="baseUrl"
                disabled
                :show-file-list="false"
              >
                <img
                  v-if="formData.photo"
                  :src="formData.photo"
                  class="avatar"
                />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
              <div class="uploadBtn">上传图片</div>
            </el-form-item>
          </div>
        </div>
        <!-- <el-form-item label="组织机构：" prop="orgName" style="height:40px">
           <el-select style="width: 100%;"
                     class="marginT34"
                     v-model="formData.orgName"
                     placeholder="请选择组织机构"
                     ref="selectBoxRef"
                     >
             <el-option :value="formData.orgName"
                       style="height: auto;">
               <el-tree :data="orgList"
                       :props="defaultProps"
               ref='tree'
                       @node-click="handleEditNodeClick"
                       class="tree_box"></el-tree>
         </el-option>
       </el-select>
     </el-form-item> -->
        <el-form-item label="居住地址:" required>
          <div class="addressContent">
            <div class="addressBox">
              <div class="addressItem">
                <el-form-item prop="shengId">
                  <el-select
                    v-model="formData.shengId"
                    placeholder="请选择省"
                    disabled
                    ref="selectShengChange"
                  >
                    <el-option
                      v-for="(item, index) in provinceList"
                      :key="index"
                      :label="item.name"
                      :value="item.adcode"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
              <div class="addressItem">
                <el-form-item prop="shiId">
                  <el-select
                    v-model="formData.shiId"
                    disabled
                    placeholder="请选择市"
                    ref="selectShiChange"
                  >
                    <el-option
                      v-for="(item, index) in cityList"
                      :key="index"
                      :label="item.name"
                      :value="item.adcode"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
              <div class="addressItem">
                <el-form-item prop="quId">
                  <el-select
                    v-model="formData.quId"
                    disabled
                    placeholder="请选择区"
                    ref="selectQuChange"
                  >
                    <el-option
                      v-for="(item, index) in areaList"
                      :key="index"
                      :label="item.name"
                      :value="item.adcode"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
              <div class="addressItem">
                <el-form-item prop="jiedaoId">
                  <el-select
                    v-model="formData.jiedaoId"
                    disabled
                    placeholder="请选择街道"
                    ref="selectJiedaoChange"
                  >
                    <el-option
                      v-for="(item, index) in streetList"
                      :key="index"
                      :label="item.name"
                      :value="item.adcode + index"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
              <div class="addressItem">
                <el-form-item prop="shequId">
                  <el-select
                    v-model="formData.shequId"
                    disabled
                    placeholder="请选择社区"
                    ref="selectShequChange"
                  >
                    <el-option
                      v-for="item in communityList"
                      :key="item.id"
                      :label="item.address"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
            </div>
            <el-form-item prop="place" style="margin: 5px 0">
              <input
                v-model.trim="formData.address"
                id="tipinput"
                disabled
                class="el-input__inner"
                @focus="getMap('tipinput')"
                placeholder="请输入关键字"
                autocomplete="off"
              />
            </el-form-item>
            <div class="map_container">
              <div id="container1" style="width: 100%; height: 200px"></div>
            </div>
          </div>
        </el-form-item>
      </el-form>
      <!-- 健康信息 -->
      <el-form
        v-show="controlAddContent == 2"
        ref="formReff"
        :model="formData"
        label-width="150px"
      >
        <el-form-item label="自理情况：" required>
          <el-radio label="0" v-model="formData.selfCare" disabled
            >较差，完全需要别人照顾
          </el-radio>
          <el-radio label="1" v-model="formData.selfCare" disabled
            >一般，有些事情需要别人照顾
          </el-radio>
          <el-radio label="2" v-model="formData.selfCare" disabled
            >较好，一般不需要别人照顾
          </el-radio>
          <el-radio label="3" v-model="formData.selfCare" disabled
            >很好，还可以照顾别人
          </el-radio>
        </el-form-item>
        <el-form-item label="健康状况：" required>
          <el-checkbox-group v-model="healthCondition" disabled>
            <el-checkbox label="0">身体健康</el-checkbox>
            <el-checkbox label="1">高血压</el-checkbox>
            <el-checkbox label="2">冠心病</el-checkbox>
            <el-checkbox label="3">脑卒中</el-checkbox>
            <el-checkbox label="4">糖尿病</el-checkbox>
            <el-checkbox label="5">类风湿</el-checkbox>
            <el-checkbox label="6">脑出血</el-checkbox>
            <el-checkbox label="7">高血脂</el-checkbox>
            <el-checkbox label="8">系统性班狼疮</el-checkbox>
            <el-checkbox label="9">恶性肿瘤</el-checkbox>
            <el-checkbox label="10">重性精神病</el-checkbox>
            <el-checkbox label="11">结核病</el-checkbox>
            <el-checkbox label="12">肝炎</el-checkbox>
            <el-checkbox label="13">其他法定传染病</el-checkbox>
            <el-checkbox label="14">其他</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import request from "@/utils/request.js"
import baseURL from "@/api/baseURL"
export default {
  props: ["oldId"],

  data() {
    return {
      query: {
        pageNo: 1,
        pageSize: 10,
      },
      dialogVisible: false,
      formData: {},
      serviceTypeList: [],
      province: "",
      city: "",
      district: "",
      street: "",
      provinceList: [], //
      cityList: [],
      areaList: [],
      streetList: [],
      polygons: [],
      communityList: [],
      titleList: [
        {
          id: "1",
          name: "基本信息",
        },
        {
          id: "2",
          name: "健康信息",
        },
      ],
      total1: 0,
      healthCondition: [],
      controlAddContent: "1", // 控制新增弹框内部内容的切换
    }
  },
  created() {
    this.getserviceType()
    this.baseUrl =
      baseURL + "/sqyl/controller/uploadController/info/uploadPhoto"
  },
  async mounted() {
    console.log(this.oldId)
    console.log(this.oldId)
    this.getData()
    await this.$nextTick(function () {
      setTimeout(() => {
        this.loadMap()
      }, 30)
    })
  },
  methods: {
    dialogVisibleClone() {
      this.$emit("setOld")
      this.dialogVisible = false
    },
    changeIdx(id) {
      this.controlAddContent = id
    },
    getData() {
      request({
        url: "/sqyl/admin/elderly/info/getById",
        method: "POST",
        data: {
          id: this.oldId.id,
        },
      }).then(async (res) => {
        console.log(res)
        if (res.code == 200) {
          this.formData = res.content
          let province = await this.getDistricts()
          this.provinceList = province.districtList
          this.formData.shengId = String(this.formData.provinceId)
          this.formData.shiId = String(this.formData.cityId)
          this.formData.quId = String(this.formData.areaId)
          this.formData.jiedaoId = String(this.formData.streetId)
          if (!this.formData.shengId) return
          let city = await this.getDistricts(this.formData.shengId)
          this.cityList = city.districtList
          if (!this.formData.shiId) return
          let area = await this.getDistricts(this.formData.shiId)
          this.areaList = area.districtList
          if (!this.formData.quId) return
          let street = await this.getDistricts(this.formData.quId)
          this.streetList = street.districtList
          if (!this.formData.jiedaoId) return
          let communityList = await this.getCommityList(this.formData.jiedaoId)
          this.communityList = communityList
          this.formData.shequId = Number(this.formData.communityId)
          this.formData.latitude = res.content.latitude
          this.formData.longitude = res.content.longitude
          console.log(this.formData.longitude)
          setTimeout(async () => {
            await this.$nextTick(() => {
              this.loadMap("container1")
              this.potintMap()
            })
          }, 30)
          this.$forceUpdate()
        } else if (res.code == "10004") {
          this.$message.error(res.message)
          this.$router.push("/login")
        }
      })
    },
    //获取服务对象数据
    getserviceType() {
      //页面初始化的时候以及查看编辑的时候展示全部
      let params = {
        pageNo: 1,
        pageSize: 100,
        type: 8,
        status: 0,
      }
      this.$http
        .request({
          url: "/jjyl/admin/ststemdata/info/findList",
          method: "POST",
          data: params,
        })
        .then((res) => {
          if (res.code == 200) {
            this.serviceTypeList = res.content.list
          } else {
            this.$message.error(res.message)
          }
        })
    },
    loadMap() {
      //地图加载
      return new Promise((resolve, reject) => {
        this.myMap = new AMap.Map("container1", {
          resizeEnable: true,
          zoom: 8,
        })
        resolve()
      })
    },
    // 打点
    potintMap() {
      const self = this
      try {
        self.myMap.remove(self.marker)
      } catch (err) {
        console.log(err)
      }
      self.marker = new AMap.Marker({
        icon: "http://webapi.amap.com/theme/v1.3/markers/n/mark_b.png",
        position: [
          Number(self.formData.longitude),
          Number(self.formData.latitude),
        ],
      })
      self.myMap.add(self.marker)
      self.myMap.setFitView()
    },
    // 社区地址列表
    getCommityList(val) {
      let self = this
      return new Promise((resolve, reject) => {
        self.$http
          .request({
            url: "/ypt/admin/standardAddress/info/StandardAddressTree",
            method: "POST",
            data: {
              jiedaoId: val,
            },
          })
          .then((res) => {
            if (res.code == 200) {
              if (!res.content) {
                resolve([])
                return
              }
              resolve(res.content)
            } else {
              resolve([])
            }
          })
      }).catch((err) => {})
    },
    // 地图
    getMap(input) {
      const self = this
      const autoOptions = {
        city: self.formData.quId,
        citylimit: true,
        input: input,
      }
      // alert(input)
      const auto = new AMap.Autocomplete(autoOptions)
      //构造地点查询类
      AMap.event.addListener(auto, "select", (e) => {
        self.formData.address = e.poi.name
        self.formData.longitude = e.poi.location.lng
        self.formData.latitude = e.poi.location.lat
        self.potintMap()
      })
    },
    //获取地址
    getDistricts(name = "中国", params = null) {
      let self = this
      return new Promise((resolve, reject) => {
        var opts = {
          subdistrict: 1, //返回下一级行政区
          extensions: "all",
          showbiz: false, //最后一级返回街道信息
        }
        let district = new AMap.DistrictSearch(opts)
        let geocoder = new AMap.Geocoder({
          city: "", //城市设为北京，默认：“全国”
          radius: 1000, //范围，默认：500
        })
        try {
          self.myMap.remove(self.marker)
        } catch (err) {}

        self.marker = new AMap.Marker()
        district.search(name, (status, result) => {
          if (status == "complete") {
            resolve(result.districtList[0])
            if (this.isMap) {
              this.isMap = false
              return
            }
            let bounds = result.districtList[0].boundaries
            self.polygon = null
          }
        })
      }).catch((err) => {})
    },
  },
}
</script>

<style lang="less" scoped>
.dialog_container {
  /deep/ .el-dialog__header {
    border-bottom: 1px solid #e5e5e5;
  }
}
.changeColor > div:first-child {
  background-color: #0000ff;
}

.changeColor > div:nth-child(2) {
  color: #0000ff;
}

.changeColor > div:last-child {
  background-color: #0000ff;
}
.name-per {
  width: 90%;
  display: flex;
  margin: 0 auto 20px;
}

.name-list {
  width: 50%;
  cursor: pointer;
  display: flex;
  justify-content: center;
  text-align: center;
}

.name-list > div:first-child {
  width: 100%;
}

.name-title {
  width: 100%;
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.name-title > div:first-child {
  width: 50%;
  height: 2px;
  background-color: #eeeeee;
}

.name-title > div:last-child {
  width: 50%;
  height: 2px;
  background-color: #eeeeee;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.rightBox {
  margin-left: 30px;
  text-align: center;
}

.uploadBtn {
  width: 170px;
  height: 50px;
  margin-left: 5px;
  background-color: #66b1ff;
  color: #fff;
  font-size: 18px;
  border-radius: 5px;
  line-height: 50px;
  margin-top: 20px;
}
.serviceInfoBox {
  display: flex;
  width: 100%;
  justify-content: flex-start;
}
.map_container1 {
  width: 89%;
  margin-left: 100px;
  margin-bottom: 20px;
}
.addressContent {
  flex: 1;

  .addressBox {
    display: flex;

    .addressItem {
      flex: 1;

      /deep/ .el-form-item__content {
        margin-left: 0px !important;
      }

      /deep/ .el-select {
        width: 100% !important;
      }
    }
  }

  /deep/ .el-form-item__content {
    margin-left: 0px !important;
  }
}
/deep/.el-input__suffix {
  margin-top: 0;
}
</style>
